
export function reindexAllQuestions(tabs) {
  let globalId = 1;
  return tabs.map((tab) => ({
    ...tab,
    content: tab.content.map((q) => ({ ...q, id: globalId++ })),
  }));
}

export function renumberTabs(tabs) {
  return tabs.map((tab, i) => ({
    ...tab,
    id: `tab${i + 1}`,
    label: `Page ${i + 1}`,
  }));
}

export function cleanTabsForSave(tabs) {
  return tabs.map((tab) => ({
    ...tab,
    content: tab.content.map(({ icon, ...rest }) => rest),
  }));
}

export const injectDraftSignatures = (formData, draftSignatures) => {
  const updatedFormData = JSON.parse(JSON.stringify(formData)); // deep copy

  Object.entries(draftSignatures).forEach(([refKey, signature]) => {
    const [tab, field] = refKey
      .split("-")
      .map((part) => part.replace(/\D/g, ""))
      .map(Number);

    if (
      updatedFormData[tab] &&
      updatedFormData[tab].content &&
      updatedFormData[tab].content[field]
    ) {
      updatedFormData[tab].content[field].answer = signature;
    }
  });

  return updatedFormData;
};
